import { ConsentService } from '../consentService';

export const consentService = new ConsentService();
